import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/page_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  slug_cont: {
    model_name: 'Page',
    column_type: 'string',
    label_key_path: 'page.slug',
  },
  title_cont: {
    model_name: 'Page',
    column_type: 'string',
    label_key_path: 'page.title',
  },
  status_eq: {
    column_type: 'enum',
    extra: {
      options: ['draft', 'published'],
    },
    model_name: 'Page',
    label_key_path: 'page.status',
  },
  application_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'page.application',
    extra: {
      model_name: 'Application',
      display_column: 'name',
    },
    model_name: 'Page',
  },
  application: {
    column_type: 'belongs_to',
    label_key_path: 'page.application',
    extra: {
      model_name: 'Application',
      display_column: 'name',
    },
    model_name: 'Page',
  },
}
export const formColumnsConfig = {
  'self': {
    'slug': { required: true, disabledUpdate: true },
    'title': { required: true, disabledUpdate: false },
    'content': { required: true, disabledUpdate: false },
    'type': { required: false, disabledUpdate: true },
    'status': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Page', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Page', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
